import { render, staticRenderFns } from "./TituloRelatorioHistoricoEscolar.vue?vue&type=template&id=7701e7f9&"
import script from "./TituloRelatorioHistoricoEscolar.vue?vue&type=script&lang=js&"
export * from "./TituloRelatorioHistoricoEscolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports